import { render, staticRenderFns } from "./ShipmentForm.vue?vue&type=template&id=574e4923&scoped=true&"
import script from "./ShipmentForm.vue?vue&type=script&lang=ts&"
export * from "./ShipmentForm.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentForm.vue?vue&type=style&index=0&id=574e4923&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e4923",
  null
  
)

export default component.exports